<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <card
            class="strpied-tabled-with-hover"
            body-classes="table-full-width table-responsive"
          >
            <template slot="header">
              <div class="d-flex justify-content-between">
                <div class="align-self-center">
                  <button
                    class="btn btn-light d-flex align-items-center text-dark p-1 border-0"
                    @click="$router.go(-1)"
                  >
                    <i class="nc-icon nc-stre-left font-weight-bold"></i>
                    <p class="m-0 ml-1">Voltar a lista</p>
                  </button>
                </div>
              </div>
              <div class="mt-3">
                <div class="float-left">
                  <h4 class="card-title">Documentos e Dados do projeto</h4>
                  <div class="mt-2">
                    <div>
                      <strong>Status: {{ mapStatus(status) }}</strong>
                    </div>
                    <div v-if="concessionariaNome" class="mt-1">
                      <strong>Concessionária: {{ concessionariaNome }}</strong>
                    </div>
                  </div>
                </div>
                <div class="float-right">
                  <button @click="saveProject" class="btn btn-success btn-fill">
                    Salvar
                  </button>
                </div>
              </div>
            </template>
            <div class="row">
              <div class="col-12">
                <vue-tabs
                  textPosition="center"
                  :centered="true"
                  class="crm-tabs"
                >
                  <v-tab title="Formulário">
                    <div class="row mb-3">
                      <div class="col-6">
                        <base-input
                          type="text"
                          label="Nome"
                          placeholder="Nome"
                          v-model="nome"
                        />
                      </div>
                      <div class="col-6">
                        <div class="d-flex flex-column mt-1">
                          <label class="mb-1">Administrador</label>
                          <multiselect
                            v-model="administradorSelecionado"
                            :options="listaAdministradores"
                            :showLabels="false"
                            placeholder="Selecione um administrador"
                            :customLabel="administradorLabel"
                            :allow-empty="true"
                          >
                            <span slot="noResult">Não encontrado</span>
                          </multiselect>
                        </div>
                      </div>
                    </div>
                    <div class="row mb-3">
                      <div class="col-12">
                        <base-input
                          type="text"
                          label="Protocolo"
                          placeholder="Protocolo"
                          v-model="protocolo"
                        />
                      </div>
                    </div>
                    <div class="row" v-if="concessionariaNome">
                      <div class="col-6">
                        <base-input
                          type="text"
                          label="Concessionária"
                          :value="concessionariaNome"
                          disabled
                        />
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12">
                        <label><strong>Placa Solar</strong></label>
                        <div class="overflow-hiden">
                          <div class="row">
                            <div class="col-6">
                              <base-input
                                type="text"
                                label="Modelo"
                                placeholder="Modelo"
                                v-model="dadosDoProjeto.placaSolar.modelo"
                              />
                            </div>
                            <div class="col-6">
                              <base-input
                                type="text"
                                label="Fabricante"
                                placeholder="Fabricante"
                                v-model="dadosDoProjeto.placaSolar.fabricante"
                              />
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-6">
                              <base-input
                                type="text"
                                label="Potência"
                                placeholder="Potência"
                                v-model="dadosDoProjeto.placaSolar.potencia"
                              />
                            </div>
                            <div class="col-6">
                              <base-input
                                type="number"
                                label="Quantidade"
                                placeholder="Quantidade"
                                v-model="dadosDoProjeto.placaSolar.quantidade"
                              ></base-input>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12">
                        <label><strong>inversor de Frequência</strong></label>
                        <div class="overflow-hiden">
                          <div class="row">
                            <div class="col-6">
                              <base-input
                                type="text"
                                label="Modelo"
                                placeholder="Modelo"
                                v-model="
                                  dadosDoProjeto.inversorDeFrequencia.modelo
                                "
                              />
                            </div>
                            <div class="col-6">
                              <base-input
                                type="text"
                                label="Fabricante"
                                placeholder="Fabricante"
                                v-model="
                                  dadosDoProjeto.inversorDeFrequencia.fabricante
                                "
                              />
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-6">
                              <base-input
                                type="text"
                                label="Potência"
                                placeholder="Potência"
                                v-model="
                                  dadosDoProjeto.inversorDeFrequencia.potencia
                                "
                              />
                            </div>
                            <div class="col-6">
                              <base-input
                                type="number"
                                label="Quantidade"
                                placeholder="Quantidade"
                                v-model="
                                  dadosDoProjeto.inversorDeFrequencia.quantidade
                                "
                              ></base-input>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12">
                        <div class="overflow-hiden">
                          <div class="row">
                            <div class="col-12">
                              <label class="mt-1 ml-1"
                                ><strong>Stringbox</strong></label
                              >
                              <textarea
                                rows="5"
                                class="form-control border-input"
                                placeholder="Descrição"
                                v-model="dadosDoProjeto.stringbox"
                              ></textarea>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12">
                        <label class="mt-2"
                          ><strong>Cabos Elétricos</strong></label
                        >
                        <div class="overflow-hiden">
                          <label class="mt-1 "
                            ><strong>Do Inversor</strong></label
                          >
                          <div class="row">
                            <div class="col-4">
                              <base-input
                                type="text"
                                label="Bitola"
                                placeholder="Bitola"
                                v-model="
                                  dadosDoProjeto.cabosEletricos.inversor.bitola
                                "
                              />
                            </div>
                            <div class="col-4">
                              <base-input
                                type="text"
                                label="Isolamento"
                                placeholder="Isolamento"
                                v-model="
                                  dadosDoProjeto.cabosEletricos.inversor
                                    .isolamento
                                "
                              />
                            </div>

                            <div class="col-4">
                              <base-input
                                type="text"
                                label="Material"
                                placeholder="Material"
                                v-model="
                                  dadosDoProjeto.cabosEletricos.inversor
                                    .material
                                "
                              />
                            </div>
                          </div>
                          <label class="mt-1"
                            ><strong>Padrão Entrada</strong></label
                          >
                          <div class="row">
                            <div class="col-4">
                              <base-input
                                type="text"
                                label="Bitola"
                                placeholder="Bitola"
                                v-model="
                                  dadosDoProjeto.cabosEletricos.padraoDeEntrada
                                    .bitola
                                "
                              />
                            </div>
                            <div class="col-4">
                              <base-input
                                type="text"
                                label="Isolamento"
                                placeholder="Isolamento"
                                v-model="
                                  dadosDoProjeto.cabosEletricos.padraoDeEntrada
                                    .isolamento
                                "
                              />
                            </div>
                            <div class="col-4">
                              <base-input
                                type="text"
                                label="Material"
                                placeholder="Material"
                                v-model="
                                  dadosDoProjeto.cabosEletricos.padraoDeEntrada
                                    .material
                                "
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <label class="ml-1"><strong>Disjuntores</strong></label>
                    <div class="row">
                      <div class="col-12">
                        <div class="overflow-hiden">
                          <div class="form-group">
                            <div class="row">
                              <div class="col-6">
                                <label class="mt-1 ml-1">Do Inversor</label>
                                <textarea
                                  rows="5"
                                  class="form-control border-input"
                                  placeholder="Disjuntor do inversor"
                                  v-model="dadosDoProjeto.disjuntores.inversor"
                                ></textarea>
                              </div>
                              <div class="col-6">
                                <label class="">Do Padrão de entrada</label>
                                <textarea
                                  rows="5"
                                  class="form-control border-input"
                                  placeholder="Disjuntor do Padrão de entrada"
                                  v-model="
                                    dadosDoProjeto.disjuntores.padraoDeEntrada
                                  "
                                ></textarea>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12">
                        <label><strong>DPS</strong></label>
                        <div class="overflow-hiden">
                          <div class="row">
                            <div class="col-6">
                              <base-input
                                type="text"
                                label="Corrente"
                                placeholder="Corrente"
                                v-model="dadosDoProjeto.dps.corrente"
                              />
                            </div>
                            <div class="col-6">
                              <base-input
                                type="text"
                                label="Classe"
                                placeholder="Classe"
                                v-model="dadosDoProjeto.dps.classe"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12">
                        <label class="mt-1 ml-1"
                          ><strong>Ligações das Placas</strong></label
                        >
                        <textarea
                          rows="5"
                          class="form-control border-input"
                          placeholder="Descrição"
                          v-model="dadosDoProjeto.ligacoesDasPlacas"
                        ></textarea>
                      </div>
                    </div>
                  </v-tab>
                  <v-tab title="Docs">
                    <l-table
                      :key="tableKey"
                      class="table-hover table-striped"
                      :columns="tabelaDocs.columns"
                      :data="tabelaDocs.data"
                    >
                      <template slot-scope="{ row, rowIndex }">
                        <td>
                          <b>{{ row.nome }}</b>
                        </td>
                        <td>
                          <button
                            class="btn btn-icon btn-success"
                            @click.prevent="uploadDocument(rowIndex)"
                          >
                            <i class="fa fa-upload"></i>
                          </button>
                        </td>
                        <td>
                          <a
                            :href="row.link"
                            target="_blank"
                            class="btn btn-icon btn-primary"
                          >
                            <i class="fa fa-download"></i>
                          </a>
                        </td>
                      </template>
                    </l-table>
                  </v-tab>
                </vue-tabs>
              </div>
            </div>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { VueTabs, VTab } from 'vue-nav-tabs';
import Multiselect from 'vue-multiselect';
import Modal from 'src/components/Modal';
import DatePicker from 'vue2-datepicker';
import LTable from 'src/components/Table.vue';
import vPagination from 'vue-plain-pagination';
import ParceiroProjectService from 'src/services/parceiroProject';
import UserServices from 'src/services/usuarios';
import _ from 'lodash';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/pt-br';

const VUE_APP_SPINNER_COLOR = process.env.VUE_APP_SPINNER_COLOR;
const tableColumns = ['Nome', 'Upload', 'Download'];

export default {
  components: {
    Multiselect,
    DatePicker,
    Modal,
    LTable,
    vPagination,
    VueTabs,
    VTab
  },
  data() {
    return {
      tableKey: 0,
      tabelaDocs: {
        columns: [...tableColumns],
        data: []
      },
      status: '',
      codigoParceiro: '',
      nome: '',
      protocolo: '',
      concessionariaNome: '',
      dadosDoProjeto: {
        placaSolar: {
          modelo: '',
          fabricante: '',
          potencia: '',
          quantidade: 0
        },
        inversorDeFrequencia: {
          modelo: '',
          fabricante: '',
          potencia: '',
          quantidade: 0
        },
        cabosEletricos: {
          inversor: {
            bitola: '',
            isolamento: '',
            material: ''
          },
          padraoDeEntrada: {
            bitola: '',
            isolamento: '',
            material: ''
          }
        },
        disjuntores: {
          inversor: '',
          padraoDeEntrada: ''
        },
        dps: {
          corrente: '',
          classe: ''
        },
        ligacoesDasPlacas: '',
        stringbox: ''
      },
      projeto: {},
      administradorSelecionado: null,
      listaAdministradores: []
    };
  },

  created() {
    this.idProjeto = this.$router.history.current.params.idProjeto;
    this.codigoParceiro = this.$router.history.current.params.codigoParceiro;
    this.loadAdministradores().then(() => {
      this.getProject();
    });
  },
  methods: {
    loadAdministradores() {
      return UserServices.listarAdministradores()
        .then(response => {
          this.listaAdministradores = response.data || [];
        })
        .catch(() => {
          this.listaAdministradores = [];
        });
    },
    administradorLabel(user) {
      if (!user) return '';
      return user.tipoParceiro === 'pf'
        ? `${user.nome} ${user.sobrenome}`
        : user.razaoSocial || '';
    },
    syncAdministradorNaLista(colaborador) {
      if (!colaborador || !colaborador._id) {
        this.administradorSelecionado = null;
        return;
      }
      const exists = this.listaAdministradores.some(
        u => u._id === colaborador._id
      );
      if (!exists) {
        this.listaAdministradores = [colaborador, ...this.listaAdministradores];
      }
      this.administradorSelecionado = this.listaAdministradores.find(
        u => u._id === colaborador._id
      );
    },
    forceRerenderTable() {
      this.tableKey += 1;
    },
    mapStatus(status) {
      const statusOptions = {
        recebido: 'Recebido',
        elaboracao: 'Elaboracao',
        em_analise: 'Em análise',
        aprovado: 'Aprovado',
        aguardando_inspecao: 'Aguardando Inspeção',
        reanalise: 'Reanálise',
        reprovado_por_debito: 'Reprovado por débito',
        finalizado: 'Finalizado'
      };

      return statusOptions[status] || 'Recebido';
    },
    getProject() {
      if (this.idProjeto) {
        const loader = this.$loading.show({
          color: VUE_APP_SPINNER_COLOR
        });

        ParceiroProjectService.get({
          id: this.idProjeto
        })
          .then(response => {
            this.projeto = response;
            this.nome = response.data.nome;
            this.protocolo = response.data.protocolo || '';
            this.concessionariaNome =
              _.get(response.data, 'concessionaria.nome') ||
              _.get(response.data, 'concessionariaNome') ||
              '';
            this.dadosDoProjeto = response.data.dados;
            this.status = response.data.status;
            this.tabelaDocs.data = response.data.downloads;
            this.syncAdministradorNaLista(response.data.colaborador);
            loader.hide();
          })
          .catch(error => {
            loader.hide();

            const message =
              _.get(error, 'response.status') === 400 &&
              _.has(error, 'response.data.message')
                ? _.get(error, 'response.data.message')
                : 'Ocorreu algum erro interno. Tente novamente mais tarde.';

            this.$notifications.notify({
              message,
              type: 'danger'
            });
          });
      }
    },
    uploadDocument(index) {
      // eslint-disable-next-line no-undef
      const myWidget = cloudinary.createUploadWidget(
        {
          cloudName: 'dy8mstmqs',
          uploadPreset: 'afqwmioy',
          sources: ['local'],
          multiple: false,
          maxFiles: 1,
          apiKey: '456183971343259'
        },
        (error, result) => {
          if (!error && result && result.event === 'success') {
            this.tabelaDocs.data[index].link = result.info.url;
            this.forceRerenderTable();
            this.notify({ type: 'success', message: 'Sucesso no Upload' });
          }
          if (error) {
            this.notify({
              type: 'error',
              message: 'Erro no upload, tente novamente'
            });
            this.forceRerenderTable();
          }
        }
      );
      myWidget.open();
    },
    saveProject() {
      if (this.idProjeto) {
        const loader = this.$loading.show({
          color: VUE_APP_SPINNER_COLOR
        });

        const payload = {
          nome: this.nome,
          dados: this.dadosDoProjeto,
          _id: this.idProjeto,
          downloads: this.tabelaDocs.data,
          colaboradorId: this.administradorSelecionado
            ? this.administradorSelecionado._id
            : null,
          protocolo:
            this.protocolo && String(this.protocolo).trim()
              ? String(this.protocolo).trim()
              : null
        };

        ParceiroProjectService.atualizar(payload)
          .then(() => {
            this.$notifications.notify({
              message: 'Atualizado com sucesso',
              type: 'success'
            });

            loader.hide();
          })
          .catch(error => {
            loader.hide();

            const message =
              _.get(error, 'response.status') === 400 &&
              _.has(error, 'response.data.message')
                ? _.get(error, 'response.data.message')
                : 'Ocorreu algum erro interno. Tente novamente mais tarde.';

            this.$notifications.notify({
              message,
              type: 'danger'
            });
          });
      }
    },
    createLoading() {
      return this.$loading.show({
        color: VUE_APP_SPINNER_COLOR
      });
    },
    notify({ type, message }) {
      let icon = '';
      switch (type) {
        case 'info':
          icon = 'fa fa-info';
          break;
        case 'success':
          icon = 'fa fa-check';
          break;
        case 'danger':
          icon = 'fa fa-exclamation-triangle';
      }
      this.$notifications.notify({
        message: `<span>${message}.</span>`,
        icon: icon,
        horizontalAlign: 'center',
        verticalAlign: 'top',
        type: type
      });
    }
  }
};
</script>
<style scoped>
.height-fit-content {
  height: fit-content;
}
.crm-tabs .nav {
  display: block !important;
}

.relatorio-geracao-form {
  border-bottom: 1px solid #e0e0e0;
}
.buttons-container {
  display: flex;
  justify-content: space-between;
  width: 100%;
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
